import { MutationKeyConfig } from './api-helper';
export const passwordApiKeyStore = {
  resetPassword: (): MutationKeyConfig => ({
    mutationKey: [`RESET_PASSWORD`],
    route: `/User/ChangePassword`,
    action: 'POST',
  }),
  resetPasswordEmail: (): MutationKeyConfig => ({
    mutationKey: [`RESET_PASSWORD_Email`],
    route: `/User/ForgotPassword`,
    action: 'POST',
  }),
  setNewPasswordWithToken: (): MutationKeyConfig => ({
    mutationKey: [`RESET_PASSWORD_WITH_TOKEN`],
    route: `/User/ResetPassword`,
    action: 'POST',
  }),
  resetPasswordAdmin: (): MutationKeyConfig => ({
    mutationKey: [`RESET_PASSWORD_ADMIN`],
    route: `/User/ChangePasswordAdmin`,
    action: 'POST',
  }),
};
